import { Literal, Union } from "runtypes";
import type { Static } from "runtypes";

export const Frequency = Union(Literal("daily"), Literal("weekly"), Literal("monthly"), Literal("one-time"), Literal("sequential-queue"));

export type Frequency = Static<typeof Frequency>;
